<template>
  <div>

    <loader v-if="!isLoaded"></loader>

    <div class="row top-button form-group-button">
      <div class="col-md-12 mt-2">
        <router-link class="btn btn-light btn-sm back mr-2"
                     :to="{name: 'quiz', params: {clientId: clientId }}">
          <i class="material-icons mdc-button__icon">arrow_back</i>
          <span>{{'quiz.backToQuizList' | trans}}</span>
        </router-link>
        <button type="submit"
                class="btn btn-primary btn-sm mb-2"
                @click.prevent="saveQuiz()"
                :disabled="disableAfterSubmit">
          {{'user.save' | trans}}
        </button>
      </div>
    </div>

    <div class="row" v-if="quizType">
      <div class="col-md-9">
        <h1 class="page-title">
          {{quizType.title}}
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">

        <dl>
          <dt>
            {{'user.client' | trans}}
          </dt>
          <dd v-if="client">
            {{client.code}}
          </dd>
          <dt>
            {{'quiz.dateAndTime' | trans }}
          </dt>
          <dd>
            {{rangeDateSheduled | toLocaleDate}} {{rangeTimeStart}}
          </dd>
          <dt>
            {{'protocol.editor' | trans}}
          </dt>
          <dd v-if="quiz">
            {{quiz.creator.displayName}}
          </dd>
        </dl>

      </div>
    </div>

    <div class="row">
      <div class="col-md-5 required">

            <v-select v-model="quizSpecialist"
                      ref="quizSpecialist"
                      :class="{'is-invalid': errors.has('field'), 'is-clear': !quizSpecialist}"
                      :options="quizSpecialistList"
                      :on-change="onChangeSpecialists"
                      label="name"
                      name="quizSpecialist"
                      :filterable="false"
                      data-vv-validate-on="none">
            </v-select>
            <label class="mdc-floating-label" :class="{'text-danger' : errorSpecialist}">{{'quiz.assignToClient' | trans}}</label>

      </div>
    </div>

    <div class="row">

      <div class="col-md-12 mt-4" v-if="quizTemplate">

        <h5 class="row-title" v-if="quiz.quiz.id === 1">{{'quiz.answersDetail' | trans}}</h5>

        <div class="row mt-2">
          <div class="col-12" v-for="(questionList, keyList) in quizTemplate.questions" :key="questionList.title">
            <h5 class="row-title" v-if="quizType.id === 2" >{{`quiz.question_titles.create_titles.${questionList.title}` | trans}}</h5>
            <table class="table table-sm" v-if="!isMobile">
              <thead class="thead-light">
              <tr>
                <th></th>
                <th class="text-center"  v-for="answer in quizTemplate.answers" :key="answer.id" > {{quizType.id === 2 ? answer.title : answer.value}} </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="question  in questionList.items" :key="question.id">
                <td :colspan="question.type==1 || question.type==4 || question.type==6 ? 1 : quizTemplate.answers.length+1">

                  <div  :class="{'text-danger': ((question.type==5 && errorAnswer(question)) || (question.type==6 && errorAnswer(question))) && afterValidate}">
                    <span v-if="keyList !== 'evaluator_information'">{{quiz.quiz.id === 1 ? question.id : question.id-22}}.</span> {{`quiz.question_titles.create_titles.${question.title}` | trans}}
                  </div>
                  <div v-if="question.type==3">
                    <mdc-textfield :id="question.group + question.id"
                                   :ref="question.group + question.id"
                                   type="text"
                                   :name="question.group + question.id"
                                   label=""
                                   class="required"
                                   :class="{'is-invalid': errors.has(question.group + question.id)}"
                                   v-validate="'required|max:5000'"
                                   v-model="question.detailedAnswer"
                                   data-vv-validate-on="none"
                                   :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                                   :data-vv-as="`quiz.question_titles.create_titles.${question.title}` | trans"/>
                    <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>
                  </div>

                  <div  v-if="question.type==5"  v-for="answer in question.answers" :key="answer.id">

                    <mdc-checkbox
                        :name="'quizTemplate' + question.group + question.id + answer.id"
                        v-model="answer.answerId"
                        :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                        :label="answer.title"/>
                  </div>

                  <div  v-if="question.type==6"  v-for="answer in question.additionalAnswers" :key="answer.id">
                    <mdc-checkbox
                        :name="'quizTemplate' + question.group + question.id + answer.id"
                        v-model="answer.answerId"
                        :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                        :label="answer.title"/>
                  </div>

                  <div v-if="question.type==5 || question.type==4">

                    <div  v-if="keyList=='evaluator_information' && question.type==4">
                      <mdc-textfield :id="question.group + question.id"
                                     :ref="question.group + question.id"
                                     type="text"
                                     v-validate="'required|max:5000'"
                                     :data-vv-as="question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain' | trans"
                                     :name="question.group + question.id"
                                     :label="question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain' | trans"
                                     :class="{'is-invalid': errors.has(question.group + question.id)}"
                                     :disabled="!question.answerId || (keyList === 'social_reinforcement' && answersSocialInfluencesLength)"
                                     v-model="question.detailedAnswer"/>
                      <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>
                    </div>
                    <div v-else>

                      <mdc-textfield :id="question.group + question.id"
                                     :ref="question.group + question.id"
                                     type="text"
                                     :name="question.group + question.id"
                                     :label="question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp' | trans"
                                     :class="{'is-invalid': errors.has(question.group + question.id)}"
                                     :disabled="question.type==4 && (!question.answerId || (question.answerId == 8)) || (keyList === 'social_reinforcement' && answersSocialInfluencesLength)"
                                     v-validate="question.type==5 ? 'max:5000' : 'required|max:5000'"
                                     :data-vv-as="question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp' | trans"
                                     v-model="question.detailedAnswer"/>
                      <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>

                    </div>

                  </div>

                </td>

                <td v-for="answer in quizTemplate.answers" class="text-center" :class="{'error-cell': !(keyList === 'social_reinforcement' && answersSocialInfluencesLength) && afterValidate && !question.answerId}" :key="answer.id" v-if="question.type==1 || question.type==4 || question.type==6">
                  <mdc-radio
                      :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                      :name="'quizTemplate' + question.group + question.id"
                      v-model="question.answerId"
                      :value="answer.id+''"
                      class="without-label-checkbox"
                  />
                  <span class="invalid-feedback" v-if="errors.has('quizTemplate' + question.group + question.id)">
                        <strong>{{ errors.first('quizTemplate' + question.group + question.id) }}</strong>
                    </span>
                </td>

              </tr>
              </tbody>
            </table>

            <div v-if="isMobile">
              <div class="row" v-for="question in quizTemplate.questions" :key="question.id" >

                <div class="col-12" v-for="question in questionList.items" :key="question.id" >

                  <div  :class="{'text-danger': ((question.type==5 && errorAnswer(question)) || (question.type==6 && errorAnswer(question))) && afterValidate}">
                    <span v-if="keyList !== 'evaluator_information'">{{quiz.quiz.id === 1 ? question.id : question.id-22}}.</span> {{`quiz.question_titles.create_titles.${question.title}` | trans}}
                  </div>

                  <div class="row">
                    <div class="col-3" v-for="answer in quizTemplate.answers" :key="answer.id" >
                      <mdc-radio
                          :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                          :name="'quizTemplate' + question.group + question.id"
                          v-model="question.answerId"
                          :value="answer.id+''"
                          :label="quiz.quiz.id === 1 ? answer.id : answer.title"
                      />
                      <span class="invalid-feedback" v-if="errors.has('quizTemplate' + question.group + question.id)">
                        <strong>{{ errors.first('quizTemplate' + question.group + question.id) }}</strong>
                    </span>
                    </div>
                  </div>


                  <div :colspan="question.type==1 || question.type==4  ? 1 : quizTemplate.answers.length+1">
                    <div v-if="question.type==3">
                      <mdc-textfield :id="question.group + question.id"
                                     :ref="question.group + question.id"
                                     type="text"
                                     :name="question.group + question.id"
                                     label=""
                                     class="required"
                                     :class="{'is-invalid': errors.has(question.group + question.id)}"
                                     v-validate="'required|max:5000'"
                                     v-model="question.detailedAnswer"
                                     data-vv-validate-on="none"
                                     :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                                     :data-vv-as="`quiz.question_titles.create_titles.${question.title}` | trans"/>
                      <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>
                    </div>

                    <div  v-if="question.type==5"  v-for="answer in question.answers" :key="answer.id">

                      <mdc-checkbox
                          :name="'quizTemplate' + question.group + question.id + answer.id"
                          v-model="answer.answerId"
                          :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                          :label="answer.title"/>
                    </div>

                    <div  v-if="question.type==6"  v-for="answer in question.additionalAnswers" :key="answer.id">
                      <mdc-checkbox
                          :name="'quizTemplate' + question.group + question.id + answer.id"
                          v-model="answer.answerId"
                          :disabled="keyList === 'social_reinforcement' && answersSocialInfluencesLength"
                          :label="answer.title"/>
                    </div>

                    <div v-if="question.type==5 || question.type==4">

                      <div  v-if="keyList=='evaluator_information' && question.type==4">
                        <mdc-textfield :id="question.group + question.id"
                                       :ref="question.group + question.id"
                                       type="text"
                                       v-validate="'required|max:5000'"
                                       :data-vv-as="question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain' | trans"
                                       :name="question.group + question.id"
                                       :label="question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain' | trans"
                                       :class="{'is-invalid': errors.has(question.group + question.id)}"
                                       :disabled="!question.answerId || (keyList === 'social_reinforcement' && answersSocialInfluencesLength)"
                                       v-model="question.detailedAnswer"/>
                        <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>
                      </div>
                      <div v-else>

                        <mdc-textfield :id="question.group + question.id"
                                       :ref="question.group + question.id"
                                       type="text"
                                       :name="question.group + question.id"
                                       :label="question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp' | trans"
                                       :class="{'is-invalid': errors.has(question.group + question.id)}"
                                       :disabled="question.type==4 && (!question.answerId || (question.answerId == 8)) || (keyList === 'social_reinforcement' && answersSocialInfluencesLength)"
                                       v-validate="question.type==5 ? 'max:5000' : 'required|max:5000'"
                                       :data-vv-as="question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp' | trans"
                                       v-model="question.detailedAnswer"/>
                        <span class="invalid-feedback" v-if="errors.has(question.group + question.id)">
                        <strong>{{ errors.first(question.group + question.id) }}</strong>
                    </span>

                      </div>

                    </div>

                  </div>


                </div>

              </div>
            </div>

            <h5 class="row-title mb-4" v-if="keyList === 'social_influences_on_behavior'" >{{'quiz.completePart2' | trans}}</h5>
          </div>
        </div>

      </div>

    </div>

    <div class="row top-button form-group-button">
      <div class="col-md-12 mt-2">
        <button type="submit"
                class="btn btn-primary btn-sm mb-2"
                @click.prevent="saveQuiz()"
                :disabled="disableAfterSubmit">
          {{'user.save' | trans}}
        </button>
      </div>
    </div>

    <mdc-dialog v-model="isModalVisible"
                :title="'quiz.errorEdit' | trans"
                :accept="'user.close' | trans"
                @accept="onModalClose"/>
  </div>
</template>

<script>

  import axios from 'axios';
  import lang from '../../../lang/translator';
  import debounce from 'lodash/debounce';
  import map from 'lodash/map';
  import join from 'lodash/join';
  import Paginate from 'vuejs-paginate';
  import Loader from '../../loader/components/Loader';
  import TableView from '../../../common/table/components/TableView';
  import {mapGetters} from 'vuex';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import filter from 'lodash/filter';
  import {Validator} from 'vee-validate';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'client': null,
      'quizId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },

    data() {
      return {
        apiUrl: 'users/',
        quizList: [],
        quizType: null,
        quizTemplate: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        minDateStart: this.getMinDateStart(new Date()),
        specialists: [],
        specialistsIds: [],
        specialist: null,
        rangeDateSheduled: null,
        rangeTimeStart: null,
        quiz: null,
        show: true,
        isLoaded: false,
        isModalVisible: false,
        disableAfterSubmit: false,
        quizSpecialist: null,
        quizSpecialistList: [],
        errorSpecialist: false,
        count: 1,
        afterValidate: false,
      };
    },

    components: {
      Loader
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapGetters('auth', [
        'user',
      ]),

      answersSocialInfluencesLength(){
        let questionsList = [];
        let answersSocialInfluencesLength = 0;

        if(this.quizType.id == 2){
          questionsList = filter(this.quizTemplate.questions, (questionsList,key) => {
            return key === 'social_influences_on_behavior'
          })[0].items;
          answersSocialInfluencesLength = filter(questionsList, item => {
            return item.answerId === "8"
          }).length;
        }

        return answersSocialInfluencesLength === questionsList.length;
      },

      disabledSave(){
        let disableSaveButton = false;
        let questionLength = 0;
        let questionAnsweredLength = 0;
        if (this.quizTemplate){

          forEach(this.quizTemplate.questions, (questionsList,key) => {

            let answ = filter(questionsList.items, item => {
              let answersQuiz = 0
              if (item.type==5){

                answersQuiz = filter(item.answers, answer => {
                  if(answer.answerId){
                    return answer.id;
                  }
                }).length;

                if(this.errorAnswer(item)){
                  questionAnsweredLength--;
                }

              }

              if (item.type==6){

                answersQuiz = filter(item.additionalAnswers, answer => {
                  if(answer.answerId){
                    return answer.id;
                  }
                }).length;

                if(this.errorAnswer(item)){
                  questionAnsweredLength--;
                }

              }

              if (key=='evaluator_information' && item.type==4){
                if (!item.detailedAnswer){
                  questionAnsweredLength--;
                }
              }

              return item.answerId || item.detailedAnswer || answersQuiz
            });


            if (!(this.answersSocialInfluencesLength  && key === 'social_reinforcement')){
              questionAnsweredLength += answ.length;
              questionLength += questionsList.items.length;
            }




          });

        }

        disableSaveButton = questionAnsweredLength < questionLength;

        return disableSaveButton;
      }

    },

    mounted: function() {



    },


    created() {
      this.show = this.$route.name === 'quiz-show';
      this.getQuizInfo();
    },

    methods: {

      errorAnswer(list){
        let errorDetail = false;

        let checkboxCount = [];
        if(list.type==5){
          checkboxCount =filter(list.answers, answ => answ.answerId).length;
        } else{
          checkboxCount =filter(list.additionalAnswers, answ => answ.answerId).length;
        }



        errorDetail = list.type==5 ? !(!!checkboxCount || !!list.detailedAnswer) : (!checkboxCount && list.answerId == 9);

        return errorDetail;
      },

      onChangeSpecialists(val) {
        this.quizSpecialist = val;
        this.errorSpecialist = false;
      },

      onModalClose(){
        this.$router.push({name: 'quiz', params: {clientId: this.clientId }});
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
      },


      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },

      getQuizInfo: async function(){

        await this.getQuizList();
        if(this.quizId) {
          try{
            let response = await this.getQuiz();

            this.quiz = response.data.data;

            this.quizType = this.quiz.quiz;

            await this.getQuizTemplate(response.data.data.quiz.id);

            this.quizSpecialistList = filter(this.quiz.assignedUnits, item => !item.passedAt);

            this.rangeDateSheduled = moment(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD')._d;
            this.rangeTimeStart = moment(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm').format("HH:mm");

            this.isLoaded = true;

          } catch (e) {
            this.isLoaded = true;
          }

        } else{
          this.quizType = this.quizList[0];
          await this.getQuizTemplate(this.quizType.id).finally(() => {
            this.isLoaded = true;
          });
        }


      },


      getQuizList: async function(){
        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/`);

          this.quizList = response.data.data.items;

          return response;

        } catch (error) {
          console.dir(error);
        }
      },



      getQuizTemplate: async function(id){

          let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/${id}`);

          let quizTemplate = response.data.data;

          forEach(quizTemplate.questions, question => {

            forEach(question.items, item => {

              if(item.type == 3 || item.type == 4 || item.type == 5){
                item.detailedAnswer = null;
              } else{
                item.answerId = null
              }

            });


          });

          this.quizTemplate = quizTemplate;

          return response;


      },

      getQuiz: async function(){

        this.isLoaded = false;

        let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/assigned/${this.quizId}`);

        return response;

      },


      saveQuiz: async function(){
        try{

          if(!this.quizSpecialist){
            this.errorSpecialist = true;
            setTimeout(() => {
              this.$refs.quizSpecialist.$el.scrollIntoView({ behavior: 'smooth'});
            }, 50);

            return;
          }

          this.afterValidate = true;
          let result = true;


          if(this.disabledSave){
            result = await this.$validator.validateAll();
            return;
          }

          if (result){
            this.disableAfterSubmit = true;

            let answers = [];

            forEach(this.quizTemplate.questions, (question,keyList) => {

              forEach(question.items, item => {

                if(keyList=='evaluator_information' && item.type==4){

                    answers.push({
                      questionId: item.id,
                      answerId: item.answerId ? +item.answerId : item.answerId,
                      detailedAnswer: item.detailedAnswer,
                    });


                } else  if (item.type==6){
                  if(item.answerId == 9){
                    let answersQuiz = filter(item.additionalAnswers, answer => {
                      if(answer.answerId){
                        return answer;
                      }

                    });

                    let answerIdList = map(answersQuiz, itemMap => itemMap.id);
                    answers.push({
                      questionId: item.id,
                      answerId: answersQuiz.length ? answerIdList : null,
                      detailedAnswer: item.detailedAnswer,
                    })

                  } else{
                    answers.push({
                      questionId: item.id,
                      answerId: item.answerId ? +item.answerId : item.answerId,
                      detailedAnswer: item.detailedAnswer,
                    })
                  }

                } else if (item.type==5){

                  let answersQuiz = filter(item.answers, answer => {
                    if(answer.answerId){
                      return answer.id;
                    }

                  });
                  let answerIdList = map(answersQuiz, itemMap => itemMap.id);
                  answers.push({
                    questionId: item.id,
                    answerId: answersQuiz.length ? answerIdList : null,
                    detailedAnswer: item.detailedAnswer,
                  });

                } else {
                  answers.push({
                    questionId: item.id,
                    answerId: item.answerId ? +item.answerId : item.answerId,
                    detailedAnswer: item.detailedAnswer,
                  })
                }

              })

            });

            let response = await axios.post(`${this.apiUrl}${this.clientId}/quiz/assigned/${this.quizId}`, {
              answers: answers,
              assignedUnitId: this.quizSpecialist.id
            });

            if (response){
              this.$router.push({name: 'quiz', params: {clientId: this.clientId }});
            }
          }

        } catch (e) {

          this.disableAfterSubmit = false;

          if(e && e.data && e.data.code === 403){
            this.isModalVisible = true;
          }

        }
      }

    },
    watch: {
      quizType(newVlaue, oldValue){
        if(oldValue){
          this.isLoaded = false;
          this.getQuizTemplate(newVlaue.id)
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/quiz/components/QuizTaking.vue